import React from "react";
import { WorldMap } from "../../../maps/world-map";
import { t } from "../../../localization/localization";

const DashboardGoogleAnalyticsMap = ({ analyticsData }) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const locale = urlSearchParams.get("locale") ?? "tr";
  const date = new Date();

  return (
    <div>
      <>
        <h3>{t(locale, "/rs/profile/google-analytics/visitor-traffic")}</h3>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "16px",
            marginBottom: "16px",
          }}
        >
          <WorldMap
            startDate={window._env_.GOOGLE_ANALYTICS_START_YEAR}
            endDate={date.toISOString().split("T")[0]}
            mapData={analyticsData}
          />
        </div>
      </>
    </div>
  );
};

export default DashboardGoogleAnalyticsMap;
